/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExchangeFacilitiesByFacilityResult } from './ExchangeFacilitiesByFacilityResult';
import {
    ExchangeFacilitiesByFacilityResultFromJSON,
    ExchangeFacilitiesByFacilityResultFromJSONTyped,
    ExchangeFacilitiesByFacilityResultToJSON,
} from './ExchangeFacilitiesByFacilityResult';

/**
 * 
 * @export
 * @interface ExchangeFacilitiesByFacilityBatchResponse
 */
export interface ExchangeFacilitiesByFacilityBatchResponse {
    /**
     * 
     * @type {Array<ExchangeFacilitiesByFacilityResult>}
     * @memberof ExchangeFacilitiesByFacilityBatchResponse
     */
    results: Array<ExchangeFacilitiesByFacilityResult>;
}

/**
 * Check if a given object implements the ExchangeFacilitiesByFacilityBatchResponse interface.
 */
export function instanceOfExchangeFacilitiesByFacilityBatchResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExchangeFacilitiesByFacilityBatchResponseFromJSON(json: any): ExchangeFacilitiesByFacilityBatchResponse {
    return ExchangeFacilitiesByFacilityBatchResponseFromJSONTyped(json, false);
}

export function ExchangeFacilitiesByFacilityBatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeFacilitiesByFacilityBatchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ExchangeFacilitiesByFacilityResultFromJSON)),
    };
}

export function ExchangeFacilitiesByFacilityBatchResponseToJSON(value?: ExchangeFacilitiesByFacilityBatchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(ExchangeFacilitiesByFacilityResultToJSON)),
    };
}

